import errorBoundary from "./errorBoundary";

export default errorBoundary;
